import React from "react"
import { useRecoilState } from "recoil"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { useSnackbar } from "notistack"
import { API, graphqlOperation } from "aws-amplify"
import { useHistory, Link as RouterLink } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import Button from "../components/Button"
import TextField from "../components/TextField"
import { updateUser as UpdateUser } from "../graphqlCustom/mutations"
import currentUser from "../store/currentUser"

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    marginTop: theme.spacing(1),
    maxWidth: 600,
  },
}))

export default function Name({ setter }) {
  const classes = useStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const [user, setUser] = useRecoilState(currentUser)

  return (
    <Formik
      initialValues={{
        firstName: user.firstName,
        lastName: user.lastName,
      }}
      validationSchema={Yup.object().shape({
        firstName: Yup.string().required("First name required"),
        lastName: Yup.string().required("Last name required"),
      })}
      onSubmit={async (values) => {
        try {
          await API.graphql(
            graphqlOperation(UpdateUser, {
              input: {
                id: user.id,
                firstName: values.firstName,
                lastName: values.lastName,
              },
            })
          )
          setUser({
            ...user,
            firstName: values.firstName,
            lastName: values.lastName,
          })
          enqueueSnackbar("Name successfully updated", {
            variant: "success",
          })
          history.push("/0/profile")
        } catch (error) {
          console.log("error", error)
          enqueueSnackbar(`Name could not be updated`, {
            variant: "error",
          })
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        isValid,
        touched,
        values,
        setFieldValue,
      }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item md={6}>
              <TextField
                autoFocus
                error={Boolean(touched.firstName && errors.firstName)}
                helperText={touched.firstName && errors.firstName}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.firstName}
                label="First Name"
                name="firstName"
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                error={Boolean(touched.lastName && errors.lastName)}
                helperText={touched.lastName && errors.lastName}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.lastName}
                label="Last Name"
                name="lastName"
              />
            </Grid>
            <Grid className={classes.container} container spacing={3} justifyContent="flex-end">
              <Grid item>
                <Button
                  color="primary"
                  component={RouterLink}
                  onClick={() => setter(false)}
                  variant="text"
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button endIcon={<ChevronRightIcon />} isLoading={isSubmitting} type="submit">
                  Update
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
